<main class="main users chart-page card card-body" id="skip-target">
    <div class="container-fluid cardone">
        <!-- <p class="stat-cards-info__title title">Excursion</p> -->
      <h2 class="main-title">Dash Board Setting</h2>
      <form [formGroup]="dashboard_seeting" (ngSubmit)="report_serarch_FormSubmit()">
        <div class="row">
            <div style="text-align: center;" class="col-lg-1 col-md-1 col-sm-3 col-xs-12">
                <label class="form-label" for="name">User</label>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  
                </div>
                <div class="col-12 ">
                  <ng-select #ngSelect formControlName="usercode">
                    <ng-option *ngFor="let sts of userlist" [value]="sts.UserCode">{{sts.UserName}}</ng-option>
                 </ng-select>
                  <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
                </div>
              </div>
              <div style="text-align: center;" class="col-lg-1 col-md-1 col-sm-6 col-xs-12">
                <label class="form-label" for="name">DashBoard View</label>
            </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                <!-- <div class="col-12 ">
                  <label class="form-label" for="name">Status</label>
                </div> -->
                <div class="col-12">
                  <ng-select formControlName="view_limit">
                    <ng-option *ngFor="let sts of this.display_type" [value]="sts['value']">{{sts['value']}}</ng-option>
                 </ng-select>
                  <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
                </div>
              </div>
         
         
          
          <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12 ">
            
            <div class="col-12 ">
              <button type="submit" class="primary-default-btn">Save</button>
              <!-- <input type="button" formControlName="name" id="name" class="form-btn" placeholder="Name" required > -->
            </div>
          </div>
          
          
          <!-- <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-12 ">
              <button type="button" style="background-color: #9e9e9e" class="primary-default-btn">Reset</button>
            </div>
          </div> -->
        </div>
        
        <div class="row">
        <br>
        </div>
        </form>
        <div class="row">
            <div style="width: 100%;" class="">
                <p-table responsiveLayout="stack" editMode="row" [value]="dashboardlist" [loading]="loading" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,25,50]" >
                    
                 
                    <ng-template pTemplate="header" let-columns>
                        <tr >
                            <th>User </th>
                            <th>Dashboard View</th>
                            <th>No Of Days</th>
                            <th>Action</th>
                            
                           
                        </tr>
                    </ng-template>
                    <ng-template   pTemplate="body" let-product  let-ri="rowIndex" let-columns="columns">
                        <tr [pEditableRow]="product" >
                            <td>
                            <span class="p-column-title">User</span>
                                    {{product.usercode}}
                               
                            </td>
                            <td>
                                <span class="p-column-title">Dashboar View</span>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <p-dropdown [options]="display_type" [(ngModel)]="product.view_limit" optionLabel="value" optionValue="value"></p-dropdown>
                                        <!-- <ng-select  [(ngModel)]="product.view_limit">
                                            <ng-option *ngFor="let sts of this.display_type" [value]="sts['id']">{{sts['value']}}</ng-option>
                                         </ng-select> -->
                                       
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.view_limit}}
                                    </ng-template>
                                </p-cellEditor>
                                </td>
                            
                            <td>
                                <span class="p-column-title">No Of Days</span>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="product.noofdays">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.noofdays}}
                                    </ng-template>
                                </p-cellEditor>
                                </td>
                            <td> <span class="p-column-title">Edit</span>
                                <div class="flex align-items-center justify-content-center gap-2">
                                    <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(product)" class="p-button-rounded p-button-text"></button>
                                    <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(product)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
                                    <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(product,ri)" class="p-button-rounded p-button-text p-button-danger"></button>
                                </div>
                            </td>
                            </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        
        
    </div>
  </main>